import * as d3 from "d3-new";
import i18n from "@/lang/lang.js";
import {createTooltip, fitFontSize, wrapVertical} from "@/shared/charts/utils";


export const generateBarChart = (data, colors, config, customGroupSorting) => {

  // set the dimensions and margins of the graph
  var { width, height, marginBottom, marginTop } = config;
  // append the svg object to the body of the page

  var svg = d3.create("svg").attr("width", width).attr("height", height);

  // List of groups = species here = value of the first column called group -> I show them on the X axis
  var groups =     customGroupSorting ?? data.map((d) => d.label);

  var padding = 0.1

  if(width / groups.length > 80){
    padding=1-(80/(width / groups.length))-0.12
  }
  // Add X axis
  var x = d3.scaleBand().domain(groups).range([0, width]).padding(padding);

  var max = Math.max(...data.map((dat) => dat.value));
  // Add Y axis
  var y = d3
    .scaleLinear()
    .domain([0, max])
    .rangeRound([height - marginBottom, marginTop]);

  var xAxis = svg
    .append("g")
    .attr("transform", "translate(0," + (y(0) + 10) + ")")
    .attr("class", "x-axis-labels")
    .call(d3.axisBottom(x).tickSize(0));
  xAxis.selectAll("path").remove();

  xAxis
    .selectAll(".tick text")
    .attr("font-size", config.axisLabelFontSize ?? "11px")
    .call(wrapVertical, x.bandwidth());

  // append labels 1
  var labels = svg
    .append("g")
    .selectAll("text")
    // Enter in data = loop group per group
    .data(data)
    .join("text")
    // .attr("transform", function(d) { return "translate(" + x(d.label) + ",0)"; })
    .attr("text-anchor", "middle")
    .attr("font-size", 80)
    .attr("x", function (d) {
      return (x(d.label) ?? 0) + x.bandwidth() / 2;
    })
    .attr("y", function (d) {
      return y(d.value);
    })
    .attr("dy", "-1.5em")
    .attr("class", "horizontal-stacked-bar-chart-percentage")
    .attr("class", "bar-chart-top-labels")
    .style("opacity", 0)
    .text((d) => `${d.value}`);
  // .call(fitFontSize, x.bandwidth() / 2);

  // append labels 2
  var labels2 = svg
    .append("g")
    .selectAll("text")
    // Enter in data = loop group per group
    .data(data)
    .join("text")
    // .attr("transform", function(d) { return "translate(" + x(d.label) + ",0)"; })
    .attr("text-anchor", "middle")
    .attr("font-size", 80)
    .attr("x", function (d) {
      return (x(d.label) ?? 0) + x.bandwidth() / 2;
    })
    .attr("y", function (d) {
      return y(d.value);
    })
    .attr("class", "horizontal-stacked-bar-chart-percentage")
    .attr("class", "bar-chart-bottom-labels")
    .style("opacity", 0)
    .attr("dy", "-0.5em")
    .text((d) => `(${d.percentage})`);
  // .call(fitFontSize, x.bandwidth() / 2);

  // Log the merged selection
  d3.selectAll([...labels, ...labels2]).call(fitFontSize, x.bandwidth() * 0.7);

  // Show the bars
  var chart = svg
    .append("g")
    .selectAll("g")
    // Enter in data = loop group per group
    .data(data)
    .join("g")
    .append("rect")
    //       .attr("transform", function(d) { return "translate(" + x(d.label) + ",0)"; })
    .attr("x", function (d) {
      return (x(d.label) ?? 0) + x.bandwidth() / 4;
    })
    .attr("y", function (d) {
      return y(d.value);
    })
    .attr("rx", 5)
    .attr("width", x.bandwidth() / 2)
    .attr("height", function (d) {
      return y(0) - y(d.value);
    })
    .attr("fill", function (d) {
      return d.color ?? colors[d.label];
    })
    .style("transform-origin", `0px ${y(0)}px`)
    .style("transform", "scaleY(0)");
  chart
    .transition()
    .duration(500)
    .style("transform", "scaleY(1)")
    .on("end", () => {
      labels
        .transition()
        .duration(300)
        .style("opacity", 1)
        .on("end", () => {});

      labels2
        .transition()
        .duration(300)
        .style("opacity", 1)
        .on("end", () => {});
    });

  createTooltip(chart, "bar-chart-tooltip", (d) => i18n.t(d.tooltipText));

  return svg.node();
};
